/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as qasAddressActions from './AddressQAS-Actions';
import * as qasAddressOperations from './AddressQAS-Operations';
import qasAddressReducer from './AddressQAS-Reducer';

export { qasAddressActions, qasAddressOperations };
export default qasAddressReducer;
